import { Component } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import {
  AuthenticationActions,
  AuthenticationSelectors,
} from '@authentication/store/authentication.slice';
import { ApiErrorResponse } from '@shared/interfaces/api-error-response';

@Component({
  selector: 'app-merchant-registration',
  templateUrl: './merchant-registration.component.html',
  styleUrls: ['./merchant-registration.component.scss'],
})
export class MerchantRegistrationComponent {
  isLoading$: Observable<boolean> = this.store.select(
    AuthenticationSelectors.selectIsLoading
  );
  errorResponse$: Observable<ApiErrorResponse | undefined> = this.store.select(
    AuthenticationSelectors.selectMerchantRegistrationErrorResponse
  );

  constructor(private store: Store) {}

  onContinue(formValue: any): void {
    this.store.dispatch(
      AuthenticationActions.registerMerchant.trigger({ data: formValue })
    );
  }
}
